import React from 'react'

import {GetStaticProps} from 'next'

import SEO from 'components/elements/SEO'
import TemplatePrivacyPolicy from 'src/components/templates/TemplatePrivacyPolicy'
import {TPageComponent} from 'src/types'
import {PrivacyPolicyPage} from 'src/types/__sanitySchema__'
import {getKeywords} from 'src/utils'

import sanityClient from '../backend/lib/sanityClient'

interface IPrivacyPolicyProps {
	pageContent: PrivacyPolicyPage
}

const PrivacyPolicy: TPageComponent<IPrivacyPolicyProps> = ({pageContent}) => {
	return (
		<>
			<SEO
				title={pageContent?.seo?.seo_title || pageContent?.title}
				description={pageContent?.seo?.meta_description}
				keywords={getKeywords(pageContent?.seo?.focus_keyword, pageContent?.seo?.focus_synonyms)}
			/>
			<TemplatePrivacyPolicy pageContent={pageContent} />
		</>
	)
}

export const getStaticProps: GetStaticProps<IPrivacyPolicyProps> = async () => {
	try {
		const privacyPolicyPage = (
			await sanityClient.fetch<PrivacyPolicyPage[]>('*[_type == "privacyPolicyPage"]')
		)[0]

		return {
			props: {
				pageContent: {...privacyPolicyPage},
			},
		}
	} catch {
		return {
			notFound: true,
		}
	}
}

PrivacyPolicy.displayName = 'PrivacyPolicy'

export default PrivacyPolicy
